module.exports = __webpack_public_path__ + "img/banner.0dd03862.png";